import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import { AppShell } from "./components/AppShell";
import { PageLoader } from "./components/PageState";

const LoginPage = lazy(() => import("./pages/LoginPage"));
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const UsersPage = lazy(() => import("./pages/UsersPage"));
const DataPage = lazy(() => import("./pages/DataPage"));
const AdminUsersPage = lazy(() => import("./pages/AdminUsersPage"));
const ProcurementPage = lazy(() => import("./pages/ProcurementPage"));
const PartnerImportsPage = lazy(() => import("./pages/PartnerImportsPage"));
const FinancePage = lazy(() => import("./pages/FinancePage"));
const PaymentLinksPage = lazy(() => import("./pages/PaymentLinksPage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));
const LiveChatPage = lazy(() => import("./pages/LiveChatPage"));
const PurchaseDetailPage = lazy(() => import("./pages/PurchaseDetailPage"));

function ProtectedRoute() {
  const { loading, access } = useAuth();
  if (loading) return <PageLoader label="กำลังตรวจสอบ Admin session" />;
  return access ? <AppShell /> : <Navigate to="/login" replace />;
}

function LoginRoute() {
  const { loading, access } = useAuth();
  if (loading) return <PageLoader label="กำลังตรวจสอบ Session" />;
  return access ? <Navigate to="/" replace /> : <LoginPage />;
}

export default function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/login" element={<LoginRoute />} />
        <Route element={<ProtectedRoute />}>
          <Route index element={<DashboardPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="trips" element={<DataPage resource="trips" />} />
          <Route path="purchases" element={<DataPage resource="purchases" />} />
          <Route path="purchases/:requestId" element={<PurchaseDetailPage />} />
          <Route path="procurement" element={<ProcurementPage />} />
          <Route path="partner-imports" element={<PartnerImportsPage />} />
          <Route path="finance" element={<FinancePage />} />
          <Route path="payment-links" element={<PaymentLinksPage />} />
          <Route path="packages" element={<DataPage resource="packages" />} />
          <Route path="packages/expected" element={<DataPage resource="expected-packages" />} />
          <Route path="deliveries" element={<DataPage resource="deliveries" />} />
          <Route path="support" element={<DataPage resource="support" />} />
          <Route path="live-chat" element={<LiveChatPage />} />
          <Route path="rentals" element={<DataPage resource="rentals" />} />
          <Route path="leave" element={<DataPage resource="leave" />} />
          <Route path="audit" element={<DataPage resource="audit" />} />
          <Route path="admins" element={<AdminUsersPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
